import {useContext, useEffect, useState} from 'react';

import { emptyGeoJSON } from "core/ui/mapping/map";

import {known_chart_ids} from "hooks/useChartsStore";

import SessionContext from 'SessionContext'

let default_radius = 5; //miles
// const hover_loc = observable.box(null);

export default function useDraggableRadius(map, onSetRadius) {
    const session = useContext(SessionContext)
    const [hover_loc, setHoverLoc] = useState(null)
    // const [activeRadiusCenter, setActiveRadiusCenter] = useState(undefined)
    // const [activeRadiusLocation, setActiveRadiusLocation] = useState(undefined)

    let activeRadiusCenter = false;
    let activeRadiusLocation = undefined;

    let prev_cursor = 'auto';

    let disabled = false;
    function disable_draggable_radius(value = true) {
        disabled = value;
    }

    // useEffect(() => {
    //     initialize()
    // }, [])    

    useEffect(() => {
        redraw_radius_hover(hover_loc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hover_loc])

    function enableDraggableRadiusForLayer(layer_id) {
        if (!map.draggable_radius_label) {
            map.draggable_radius_label = document.createElement('div');
            map.draggable_radius_label.className = 'active-radius-label';
            map.draggable_radius_label.style.display = 'none';
            const map_container = map.getCanvasContainer();
            map_container.appendChild(map.draggable_radius_label);

            if (!map.getSource('active-radius')) {
                map.addSource('active-radius', emptyGeoJSON());
            }

            if (!map.getLayer('active-radius')) {
                map.addLayer({
                    'id': 'active-radius',
                    'type': 'fill',
                    'source': 'active-radius',
                    'layout': {
                        'visibility': 'none'
                    },
                    'paint': {
                        'fill-color': '#AAB6BC',
                        'fill-opacity': 0.25,
                    }
                }, map.getFirstLayerID()); // Add at lowest layer
            }

            if (!map.getLayer('active-radius-outline')) {
                map.addLayer({
                    'id': 'active-radius-outline',
                    'type': 'line',
                    'source': 'active-radius',
                    'layout': {
                        'visibility': 'none'
                    },
                    'paint': {
                        'line-color': '#d50057',
                        'line-width': 1,
                        'line-dasharray': [4, 4]
                    }
                });
            }

            if (!map.getSource('location-radius-filters')) {
                map.addSource('location-radius-filters', emptyGeoJSON());
            }
            if (!map.getLayer('location-radius-filters')) {
                map.addLayer({
                    'id': 'location-radius-filters',
                    'type': 'fill',
                    'source': 'location-radius-filters',
                    'paint': {
                        'fill-color': '#AAB6BC',
                        'fill-opacity': 0.25
                    }
                }, map.getFirstLayerID()); // Add at lowest layer
            }

            if (!map.getSource('location-radius-hover')) {
                map.addSource('location-radius-hover', emptyGeoJSON());
            }
            if (!map.getLayer('location-radius-hover')) {
                map.addLayer({
                    'id': 'location-radius-hover',
                    'type': 'line',
                    'source': 'location-radius-hover',
                    'paint': {
                        'line-color': '#d50057',
                        'line-width': 1,
                        'line-dasharray': [4, 4]
                    }
                });
            }
        }

        map.on('mousedown', layer_id, (e) => {
            if (disabled) return;
            e.preventDefault(); // disable default map-drag behavior
            const loc = e.features[0].properties;
            activeRadiusCenter = [parseFloat(loc.lng), parseFloat(loc.lat)]
            activeRadiusLocation = loc
            // popup_control.disable();
        });

        map.on('mouseup', layer_id, (e) => {
            if (disabled) return;
            const loc = e.features[0].properties;
            if (activeRadiusLocation && loc.id === activeRadiusLocation.id) {
                cancelRadius();
                // cancelRadius(map, layer_id);
                // const coordinates = e.features[0].geometry.coordinates;
                // const popupContent = renderLocationPopup(e.features[0].properties);
                // popup_control.open(coordinates, popupContent);
            }
            map.getCanvas().style.cursor = prev_cursor;
        });
        map.on('mouseleave', layer_id, (e) => {
            if (disabled) return;
            setHoverLoc(null)
            if (activeRadiusCenter) {
                map.draggable_radius_label.innerText = '';
                map.draggable_radius_label.style.display = 'block';
    
                resetRadius();
                map.setLayoutProperty('active-radius', 'visibility', 'visible');
                map.setLayoutProperty('active-radius-outline', 'visibility', 'visible');
                map.on('mousemove', drawRadius);
                map.on('mouseup', _setRadius);
            }
            map.getCanvas().style.cursor = prev_cursor;
        });
        map.on('mouseenter', layer_id, (e) => {
            if (disabled) return;
            const loc = e.features[0].properties;
            if (activeRadiusLocation && loc.id === activeRadiusLocation.id) {
                cancelRadius(true);
            }
            if (!activeRadiusLocation) {
                setHoverLoc((prevValue) => {
                    if (JSON.stringify(prevValue) !== JSON.stringify(e.features[0].properties)) {
                        const canvas = map.getCanvas();
                        prev_cursor = canvas.style.cursor;
                        canvas.style.cursor = 'nwse-resize';
                        
                        return e.features[0].properties
                    }
                    return prevValue
                })
            }
        });
        map.on('click', layer_id, (e) => {
            if (disabled) return;
            setRadius(default_radius);
        });
    }

    function redraw_radius_hover(newValue) {
        if (map && map.getSource('location-radius-hover')) {
            map.getSource('location-radius-hover').setData({
                'type': 'FeatureCollection',
                'features': newValue === null ? [] : [{
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        'coordinates': [createGeoJSONCircle([newValue.lng, newValue.lat], default_radius)]
                    }
                }]
            });
        }
    }

    function redraw_location_radius_filters() {
        if(map && map.getSource('location-radius-filters')) {
            const location_filters = session.crossfilterStore.filters[known_chart_ids.locations] || [];
            map.getSource('location-radius-filters').setData({
                'type': 'FeatureCollection',
                'features': location_filters.map((filter) => ({
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        'coordinates': [createGeoJSONCircle([filter.location.lng, filter.location.lat], filter.value)]
                    }
                }))
            });
        }
    }

    function drawRadius(ev) {
        const radius = distanceBetween(activeRadiusCenter[1], activeRadiusCenter[0],
            ev.lngLat.lat, ev.lngLat.lng);
        map.draggable_radius_label.innerText = radius ? `${radius.toFixed(1)} mi` : '';
        map.draggable_radius_label.style.transform = `translate(${ev.point.x}px, ${ev.point.y}px)`;
        map.getSource('active-radius').setData(
            {
                'type': 'Feature',
                'geometry': {
                    'type': 'Polygon',
                    'coordinates': [createGeoJSONCircle(activeRadiusCenter, radius)]
                }
            }
        );
    }

    function resetRadius() {
        const radius = 0;
        map.getSource('active-radius').setData(
            {
                'type': 'Feature',
                'geometry': {
                    'type': 'Polygon',
                    'coordinates': [createGeoJSONCircle(activeRadiusCenter, radius)]
                }
            }
        );
    }

    function cancelRadius(keep_armed = false) {
        map.off('mouseup', _setRadius);
        map.off('mousemove', drawRadius);
        if (!keep_armed) {
            activeRadiusCenter = false;
            activeRadiusLocation = undefined;
        }
        map.draggable_radius_label.style.display = 'none';
        map.draggable_radius_label.innerText = '';
        map.setLayoutProperty('active-radius', 'visibility', 'none');
        map.setLayoutProperty('active-radius-outline', 'visibility', 'none');
        // popup_control.enable();
    }

    function _setRadius(e) {
        const radius = distanceBetween(activeRadiusCenter[1], activeRadiusCenter[0],
            e.lngLat.lat, e.lngLat.lng).toFixed(1);
        setRadius(radius)
    }

    async function setRadius(radius) {
        // build the new filter
        if (activeRadiusLocation) {
            const location = activeRadiusLocation;
            // check the radius size
            if(radius && (parseFloat(radius) > parseFloat(window.locations_max_radius_value)) ) {
              radius = window.locations_max_radius_value;
            }
            const filterIsNeg = session.crossfilterStore.filters.locations?.length && session.crossfilterStore.filters.locations[0].is_negated ? true : false;
            const new_filter = { series: location.series, value: radius, is_negated: filterIsNeg, location };
            cancelRadius();

            // add or replace the filter in the filters list
            if (onSetRadius) await onSetRadius(location, new_filter);
            session.crossfilterStore.update_location_filter(location, new_filter)
            default_radius = radius;
        }
    }

    return {
        enableDraggableRadiusForLayer: enableDraggableRadiusForLayer,
        redraw_location_radius_filters: redraw_location_radius_filters,
        disable_draggable_radius: disable_draggable_radius
    }
};



/********
 * Event Handler Functions. Used Internally
 ******** */


function createGeoJSONCircle(center, radiusInMiles, points) {
    if (!points) {
        points = 64;
    }
    const coords = {
        latitude: parseFloat(center[1]),
        longitude: parseFloat(center[0])
    };
    const km = radiusInMiles * 1.60934;
    const geometry = [];
    const distanceX = km / (111.320 * Math.cos((coords.latitude * Math.PI) / 180));
    const distanceY = km / 110.574;
    let theta = undefined;
    let x = undefined;
    let y = undefined;
    let i = 0;
    while (i < points) {
        theta = (i / points) * 2 * Math.PI;
        x = distanceX * Math.cos(theta);
        y = distanceY * Math.sin(theta);
        geometry.push([
            coords.longitude + x,
            coords.latitude + y
        ]);
        i++;
    }
    return geometry;
}
export { createGeoJSONCircle };



function distanceBetween(lat1, lon1, lat2, lon2, unit) {
    const radlat1 = Math.PI * lat1 / 180;
    const radlat2 = Math.PI * lat2 / 180;
    const theta = lon1 - lon2;
    const radtheta = Math.PI * theta / 180;
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === "K") { dist = dist * 1.609344 }
    if (unit === "N") { dist = dist * 0.8684 }
    return dist
}

